<template>
  <div class="select mw-100">
    <div
      data-grid="column"
      class="select__wrapper h-100"
    >
      <label
        v-if="label"
        :for="name"
        class="select__label cursor-pointer"
      >
        {{ label }}
      </label>

      <div
        class="select__content p-relative"
        :class="{ 'mt-2': label }"
      >
        <select
          :id="name"
          :value="modelValue"
          v-bind="{
            name,
            disabled,
            readonly,
            required
          }"
          class="select__element w-100 h-100"
          @change.stop="$e => updateValue($e.target.value)"
        >
          <option
            v-if="defaultOption"
            disabled
            selected
            value=""
          >
            {{ defaultOption }}
          </option>

          <slot v-if="!groupOptions">
            <option
              v-for="option in options"
              :key="option.id"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </slot>

          <slot v-else>
            <optgroup
              v-for="{ label: localLabel, data } in options"
              :key="localLabel"
              :label="localLabel"
            >
              <option
                v-for="option in data"
                :key="option.id"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </optgroup>
          </slot>
        </select>

        <div
          v-if="hasControls && !disabled && !readonly"
          data-grid="column"
          class="select__controls p-absolute h-100 grid--center"
        >
          <div
            class="select__control select__control--up w-100"
            @click.stop="arrowChange(-1)"
          >
            <ChevronTopIcon />
          </div>

          <div
            class="select__control select__control--down w-100"
            @click.stop="arrowChange(1)"
          >
            <ChevronTopIcon />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import ChevronTopIcon from '../icons/ChevronTopIcon.vue'

export default defineComponent({
  name: 'SelectList',

  components: {
    ChevronTopIcon
  },

  props: {
    options: {
      type: Array,
      default: () => []
    },

    modelValue: {
      type: [Number, String],
      default: ''
    },

    defaultOption: {
      type: String,
      default: ''
    },

    name: {
      type: String,
      default: () => ''
    },

    label: {
      type: String,
      default: () => ''
    },

    hasControls: Boolean,

    disabled: Boolean,

    readonly: Boolean,

    required: Boolean,

    groupOptions: Boolean
  },

  emits: ['update:modelValue'],

  methods: {
    updateValue (v) {
      this.$emit('update:modelValue', v)
    },

    arrowChange (increment) {
      const { options, updateValue, modelValue } = this

      const len = options.length

      if (!len) return

      const currentSelectedIndex = options.findIndex(({ value }) => value === modelValue)

      if (currentSelectedIndex < 1 && increment < 0) {
        return
      }

      const newSelectedOptionIndex = Math.min(len - 1, currentSelectedIndex + increment)

      if (newSelectedOptionIndex !== currentSelectedIndex) {
        updateValue(options[newSelectedOptionIndex].value)
      }
    }
  }
})
</script>

<style lang="scss">
  .select {
    &__content {
      border: solid var(--borderWidth, 1px) var(--borderColor, rgb(var(--gray9)));
    }

    &__element {
      color: inherit;
      border: 0 none;
      appearance: none;
      border-radius: inherit;
    }

    &__controls {
      opacity: 0;
      visibility: hidden;

      top: 0;
      right: 5px;
      width: 18px;
      color: var(--borderColor);
      transition: all .2s ease-in-out;

      :hover > & {
        opacity: 1;
        visibility: visible;
      }
    }

    &__control {
      height: 18px;

      &--down {
        transform: rotate(180deg);
      }
    }
  }
</style>
